import React from 'react';

const Logo = () => (
  <svg
    width='41'
    height='41'
    viewBox='0 0 41 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.1044 8.63042C31.9476 8.50719 31.8691 8.30553 31.8691 8.11507C31.8691 7.92461 31.9476 7.71175 32.1044 7.59971C32.4294 7.31963 32.9 7.31963 33.2249 7.59971C33.3818 7.72295 33.4602 7.92461 33.4602 8.11507C33.4602 8.30553 33.3818 8.51839 33.2249 8.63042C32.9448 8.91051 32.4182 8.91051 32.1044 8.63042Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M30.1001 10.7142C29.9769 10.5574 29.8984 10.3893 29.8984 10.1988C29.8984 9.79552 30.2234 9.43701 30.6604 9.43701C30.862 9.43701 31.0637 9.51544 31.1758 9.67228C31.299 9.82913 31.3775 9.99718 31.3775 10.1876C31.3775 10.3893 31.299 10.591 31.1758 10.703C31.0189 10.8262 30.8508 10.9047 30.6604 10.9047C30.4251 10.9159 30.257 10.8374 30.1001 10.7142Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.9034 12.7984C27.6233 12.5183 27.6233 12.0365 27.9034 11.7565C28.1836 11.4764 28.6654 11.4764 28.9791 11.7565C29.2592 12.0365 29.2592 12.5183 28.9791 12.7984C28.8558 12.9552 28.6542 13.0336 28.4637 13.0336C28.2172 13.0336 28.0603 12.9552 27.9034 12.7984Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.8198 14.9159C25.5397 14.6358 25.4948 14.1989 25.775 13.874L25.8198 13.8292C26.1447 13.5491 26.6153 13.5491 26.9402 13.8292C27.2204 14.1093 27.2652 14.5462 26.9851 14.8711L26.9402 14.9159C26.7834 15.0728 26.5817 15.1176 26.38 15.1176C26.1783 15.1176 25.9766 15.0728 25.8198 14.9159Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.8134 17.033C23.6566 16.9098 23.5781 16.7081 23.5781 16.5177C23.5781 16.1144 23.9367 15.7559 24.34 15.8007C24.5417 15.8007 24.6986 15.8791 24.8218 16.0023C24.9787 16.1256 25.0235 16.3272 25.0235 16.5177C25.0235 16.921 24.6986 17.2795 24.2616 17.2795C24.1384 17.2347 23.9367 17.1563 23.8134 17.033Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.3711 18.6018C21.3711 18.4002 21.4495 18.1985 21.6064 18.0865C21.9313 17.8064 22.4019 17.8512 22.682 18.1313C22.9173 18.4114 22.9173 18.8483 22.682 19.1284C22.4019 19.4085 21.9201 19.4085 21.64 19.1284C21.4607 18.9603 21.3711 18.7923 21.3711 18.6018Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.4945 23.1949C17.3377 23.038 17.2592 22.87 17.2928 22.6795C17.2928 22.4779 17.3713 22.2762 17.4945 22.1642C17.7746 21.8841 18.2564 21.8841 18.5702 22.1642C18.6934 22.2874 18.7719 22.4891 18.7719 22.6795C18.7719 22.87 18.6934 23.0828 18.5366 23.1949C18.4133 23.3517 18.2116 23.4302 18.0211 23.4302C17.8083 23.4414 17.6514 23.3629 17.4945 23.1949Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.2861 25.3238C15.1292 25.2005 15.0508 24.9989 15.0508 24.8084C15.0508 24.6068 15.1292 24.4499 15.2861 24.2931C15.611 24.013 16.1264 24.013 16.4514 24.2931C16.6082 24.4163 16.6867 24.618 16.6867 24.8084C16.6867 25.0101 16.6082 25.1669 16.4514 25.3238C16.2945 25.4806 16.0928 25.5591 15.8911 25.5591C15.6558 25.5254 15.4542 25.4358 15.2861 25.3238Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.2921 27.4409C13.012 27.1608 13.012 26.679 13.2921 26.3653C13.5722 26.0853 14.054 26.0853 14.3678 26.3653C14.6479 26.6454 14.6479 27.1272 14.3678 27.4409C14.2109 27.5641 14.0428 27.6425 13.8524 27.6425C13.6059 27.6425 13.449 27.5641 13.2921 27.4409Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.208 29.5247C11.0511 29.3679 10.9727 29.1998 10.9727 29.0094C10.9727 28.6061 11.3312 28.2476 11.7346 28.2476C11.9363 28.2476 12.1379 28.326 12.25 28.4492C12.3732 28.6061 12.4517 28.7741 12.4517 28.9646C12.4517 29.155 12.3732 29.3679 12.25 29.4799C12.0931 29.6032 11.9251 29.6816 11.7346 29.6816C11.5329 29.7264 11.3312 29.6816 11.208 29.5247Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.01264 31.6421C8.85578 31.5189 8.77734 31.3172 8.77734 31.1268C8.77734 30.9251 8.85578 30.7235 9.01264 30.6114C9.33758 30.3313 9.80818 30.3313 10.1331 30.6114C10.29 30.7347 10.3684 30.9363 10.3684 31.1268C10.3684 31.3285 10.29 31.5301 10.1331 31.6421C9.80818 31.9222 9.32638 31.9222 9.01264 31.6421Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.00696 33.726C6.72685 33.4459 6.72685 32.9642 7.00696 32.6505C7.28708 32.3704 7.76888 32.3704 8.049 32.6505C8.32912 32.9306 8.32912 33.4123 8.049 33.726C7.76888 34.0061 7.28708 34.0061 7.00696 33.726Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.04923 8.6307C8.17249 8.47386 8.25092 8.30581 8.25092 8.11535C8.25092 7.71202 7.92598 7.35352 7.489 7.35352C7.28731 7.35352 7.08563 7.43194 6.97358 7.55518C6.81671 7.67841 6.73828 7.88008 6.73828 8.07053C6.73828 8.27219 6.81671 8.47386 6.97358 8.58589C7.28731 8.91079 7.76912 8.91079 8.04923 8.6307Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.1331 10.7144C10.29 10.5912 10.3684 10.3895 10.3684 10.1991C10.3684 9.99739 10.29 9.79573 10.1331 9.6837C9.80818 9.40361 9.33758 9.40361 9.01264 9.6837C8.85578 9.80693 8.77734 10.0086 8.77734 10.1991C8.77734 10.4007 8.85578 10.6024 9.01264 10.7144C9.32638 10.9945 9.80818 10.9945 10.1331 10.7144Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2504 12.7984C12.5305 12.5183 12.5305 12.0365 12.2504 11.7565C11.9703 11.4764 11.4885 11.4764 11.1748 11.7565C11.0515 11.8797 10.9731 12.0813 10.9395 12.2718C10.9395 12.4735 11.0179 12.6751 11.1411 12.7872C11.2644 12.944 11.4661 13.0224 11.6566 13.0224C11.9255 13.0336 12.1272 12.9552 12.2504 12.7984Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.3678 14.9155C14.6479 14.6354 14.6479 14.1536 14.3678 13.8399C14.0877 13.5599 13.6059 13.5599 13.2921 13.8399C13.012 14.12 13.012 14.6018 13.2921 14.9155C13.449 15.0723 13.6171 15.1171 13.8075 15.1171C13.998 15.1171 14.2109 15.0387 14.3678 14.9155Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.4515 17.0332C16.6083 16.9099 16.6868 16.7083 16.6868 16.5178C16.6868 16.3274 16.6083 16.1145 16.4515 16.0025C16.1265 15.6776 15.6559 15.6776 15.331 16.0025C15.1741 16.1257 15.0957 16.3274 15.0957 16.5178C15.0957 16.7083 15.1741 16.9211 15.331 17.0332C15.6559 17.3133 16.1265 17.3133 16.4515 17.0332Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.7706 18.6014C18.7706 18.3997 18.6922 18.1981 18.5353 18.086C18.2552 17.806 17.7734 17.806 17.4933 18.086C17.2132 18.3661 17.2132 18.8479 17.4933 19.1616C17.7734 19.4417 18.2552 19.4417 18.5689 19.1616C18.6922 18.9599 18.7706 18.7919 18.7706 18.6014Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.6529 21.2343C20.933 20.9542 20.933 20.4725 20.6529 20.1588C20.3728 19.8787 19.891 19.8787 19.5773 20.1588C19.2972 20.4389 19.2972 20.9206 19.5773 21.2343C19.891 21.5144 20.3728 21.5144 20.6529 21.2343Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.7386 23.1949C22.8954 23.0716 22.9739 22.87 22.9739 22.6795C22.9739 22.4891 22.8954 22.2762 22.7386 22.1642C22.4136 21.8841 21.943 21.8841 21.6181 22.1642C21.4612 22.2874 21.3828 22.4891 21.3828 22.6795C21.3828 22.87 21.4612 23.0828 21.6181 23.1949C21.775 23.3517 21.9767 23.4302 22.1783 23.4302C22.38 23.4302 22.5817 23.3629 22.7386 23.1949Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.8539 25.3238C24.9772 25.2005 25.0556 24.9989 25.0556 24.8084C25.0556 24.6068 24.9772 24.4499 24.8539 24.2931C24.5738 24.013 24.092 24.013 23.7783 24.2931C23.6214 24.4499 23.543 24.618 23.543 24.8084C23.543 25.2117 23.9015 25.5254 24.3049 25.5254C24.5402 25.5254 24.7307 25.4358 24.8539 25.3238Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.985 27.4409C27.2651 27.1608 27.2651 26.679 26.985 26.3653C26.7048 26.0853 26.223 26.0853 25.9093 26.3653C25.6292 26.6454 25.6292 27.1272 25.9093 27.4409C26.0662 27.5977 26.2342 27.6425 26.4247 27.6425C26.6152 27.6425 26.8169 27.5641 26.985 27.4409Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.9468 29.525C29.1037 29.3681 29.1821 29.2001 29.1821 29.0096C29.1821 28.8079 29.1037 28.6063 28.9468 28.4942C28.6667 28.2142 28.1849 28.2142 27.9048 28.4942C27.7816 28.6511 27.7031 28.8191 27.7031 29.0096C27.7031 29.2113 27.7816 29.4129 27.9048 29.525C28.0617 29.6818 28.2297 29.7266 28.4202 29.7266C28.6219 29.7266 28.8236 29.6818 28.9468 29.525Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.142 31.6425C31.2989 31.4857 31.3773 31.3176 31.3773 31.0824C31.3773 30.8807 31.2989 30.679 31.142 30.567C30.8619 30.2869 30.3801 30.2869 30.1 30.567C29.9431 30.7238 29.8647 30.8919 29.8983 31.0824C29.8983 31.284 29.9767 31.4857 30.1 31.5977C30.3801 31.9226 30.8619 31.9226 31.142 31.6425Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M33.2583 33.7265C33.5384 33.4464 33.5384 33.0095 33.3031 32.6846C33.3031 32.6846 33.3031 32.6846 33.2583 32.6398C32.9334 32.3597 32.4628 32.3597 32.1378 32.6398C31.8577 32.875 31.8129 33.3568 32.0594 33.6368C32.1042 33.6817 32.1042 33.6817 32.1378 33.7153C32.4628 34.0402 32.9446 34.0402 33.2583 33.7265Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.0111 9.19076C17.2913 6.43472 22.8152 6.43472 27.0954 9.19076L31.6221 4.70939C24.8545 -0.657037 15.2856 -0.657037 8.48438 4.70939L13.0111 9.19076Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.48547 27.6763C5.63947 23.3966 5.63947 17.8734 8.48547 13.5937L4.00358 9.1123C-1.28505 15.8792 -1.28505 25.4021 4.00358 32.1689L8.48547 27.6763Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.1402 32.1689C25.0562 33.6142 22.6135 34.3648 20.0925 34.3648C17.5714 34.4096 15.0503 33.6478 12.9663 32.2026L8.48438 36.6839C11.7674 39.3279 15.8907 40.7283 20.0925 40.6835C24.2606 40.6835 28.2943 39.2383 31.5773 36.6391L27.1402 32.1689Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.5449 13.5937C32.9903 15.7112 33.7074 18.1983 33.6626 20.7527C33.6178 23.2287 32.9007 25.6374 31.5449 27.6764L36.0716 32.1578C38.6711 28.92 40.0717 24.8756 40.1165 20.7079C40.1614 16.5066 38.7608 12.3838 36.1164 9.10117L31.5449 13.5937Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36.2281 33.5244C37.9872 33.5244 39.3878 34.9248 39.3878 36.6838C39.3878 38.4427 37.9872 39.8431 36.2281 39.8431C34.4689 39.8431 33.0684 38.4427 33.0684 36.6838C33.102 34.9248 34.5026 33.5244 36.2281 33.5244Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.95943 33.5244C5.68496 33.6028 7.04073 35.0481 6.99591 36.807C6.9511 38.4427 5.59532 39.7647 3.95943 39.8431C2.23391 39.7647 0.878136 38.3195 0.922955 36.5605C1.00139 34.9248 2.32355 33.6028 3.95943 33.5244Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36.3058 1.30371C38.0313 1.30371 39.4319 2.74895 39.4319 4.46307C39.4319 6.17719 38.0313 7.55521 36.3058 7.55521C34.5803 7.55521 33.1797 6.15478 33.1797 4.47427C33.1797 2.74895 34.5467 1.34852 36.3058 1.30371Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.92536 1.30371C5.65088 1.30371 7.05147 2.65932 7.08509 4.38465C7.08509 6.10997 5.63968 7.5104 3.92536 7.5104C2.19983 7.5104 0.799239 6.15479 0.765625 4.38465C0.765625 2.70414 2.19983 1.30371 3.92536 1.30371Z'
      fill='white'
    />
  </svg>
);

export default Logo;
